export { default } from './FormInfoPage.vue'
